import request from "./request";
import apis from "./apis";

const {
  allLostItem,
  lostItemInfo,
} = apis.lostAndFound;

const lostAndFound = {
  getAllLostItemInfo: (data: Object) => {
    return request.get(allLostItem, data);
  },
  createLostItemInfo: (data: Object) => {
    return request.formJsonPost(lostItemInfo, data);
  },
  updateLostItemInfo: (data: Object) => {
    return request.formJsonPut(lostItemInfo, data);
  },
  deleteLostItemInfo: (data: Object) => {
    return request.delete(lostItemInfo, data);
  },
};

export default lostAndFound;